import Divider from '@mui/material/Divider';

export default function OrderDetails(props) {
  const orderItems = props.order ? props.order.items : null;

  function calculateTotalItemPrice(price, count) {
    var value = (Math.round((price * count) * 100)/100).toFixed(2);
    return value;
  }


  function formatToTwoDecimalPlaces(amount) {
    return Number(amount).toFixed(2);
  }

  if (props.isCheckingOut) {
    return <div style={{ marginBottom: '16px'}}>Total amount to be charged: ${formatToTwoDecimalPlaces(props.order.totalAmount)}</div>;
  }

  return (
    <div>
        <Divider style={{ marginTop: 64, marginBottom: 24 }}/>
        { orderItems && orderItems.length > 0 ? (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', gap:24, justifyContent: 'space-between', flexWrap: 'wrap' }}>

            <div style={{ display: 'flex', flexDirection: 'column', gap:2 }}>
                <div style={{ marginBottom: 16 }}><b>Order Summary</b></div>
                {orderItems.map(item => (
                    <div key={item.menuItemId} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span data-testid={'menu-item-name-' + item.menuItemId}>{item.itemName + ' (' + item.count + ')'}:</span>
                        <span data-testid={'menu-item-price-' + item.menuItemId} style={{ marginLeft: 24 }}>${calculateTotalItemPrice(item.price, item.count)}</span>
                    </div>
                ))}
                
                <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between' }}>
                    <span>Item(s) Subtotal:</span>
                    <span style={{ marginLeft: 24 }}>${formatToTwoDecimalPlaces(props.order.itemsSubTotal)}</span>
                </div>
                {props.order.deliveryFee > 0 && (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>Delivery Fee:</span>
                      <span style={{ marginLeft: 24 }}>${formatToTwoDecimalPlaces(props.order.deliveryFee)}</span>
                    </div>
                    <div style={{ fontSize: '0.8rem', color: '#666', marginTop: 2 }}>
                      <span>
                        {formatToTwoDecimalPlaces(props.order.deliveryDistanceMiles)} miles × ${(props.order.deliveryFee / (props.order.deliveryDistanceMiles || 1)).toFixed(2)}/mile
                      </span>
                    </div>
                  </>
                )}
                {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Fees:</span>
                    <span style={{ marginLeft: 24 }}>${formatToTwoDecimalPlaces(props.order.fees)}</span>
                </div> */}
                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', borderTop: '1px solid #ddd', paddingTop: 8, marginTop: 8 }}>
                    <span>Grand Total:</span>
                    <span style={{ marginLeft: 24 }}>${formatToTwoDecimalPlaces(props.order.totalAmount)}</span>
                </div>
            </div> 
            </div>
        </div>
        ) : (
            <p style={{ color: 'gray' }}><i>no items selected yet</i></p>
        )}
    </div>
  );
}